<template>
  <header
    class="sticky top-0 z-50 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 shadow-sm"
  >
    <div class="container mx-auto px-4">
      <div class="flex items-center justify-between h-16">
        <!-- Logo -->
        <router-link to="/" class="flex items-center">
          <img :src="logoSrc" alt="Jukebox Logo" class="h-10 w-auto" />
        </router-link>

        <!-- Right side: Language Switcher + Theme Toggle -->
        <div class="flex items-center gap-3">
          <LanguageSwitcher
            v-if="showLanguageSwitcher"
            :available-locales="switcherLocales"
          />
          <button
            v-if="showThemeToggle"
            class="w-12 h-10 flex items-center justify-center border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors theme-toggle-button"
            :aria-label="themeStore.isDark ? 'Switch to light theme' : 'Switch to dark theme'"
            @click="themeStore.toggleTheme"
          >
            <i
              :class="themeStore.isDark ? 'pi pi-sun' : 'pi pi-moon'"
              class="text-xl text-gray-700 dark:text-gray-300"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useThemeStore } from "../stores/theme";
import { useConcertsStyleStore } from "../stores/concertsStyle";
import { useEventPageStore } from "../stores/eventPage";
import LanguageSwitcher from "./LanguageSwitcher.vue";

const route = useRoute();
const themeStore = useThemeStore();
const concertsStyleStore = useConcertsStyleStore();
const eventPageStore = useEventPageStore();

const logoSrc = computed(() => {
  if (route.params.slug) {
    return concertsStyleStore.logoSrc(themeStore.isDark);
  }
  return themeStore.logoSrc;
});

const showThemeToggle = computed(() => {
  if (route.params.slug && concertsStyleStore.isWise) {
    return false;
  }
  return true;
});

const showLanguageSwitcher = computed(() => {
  if (!route.params.slug) {
    return true;
  }
  return eventPageStore.enabledLocales.length > 1;
});

const switcherLocales = computed(() => {
  if (!route.params.slug) {
    return null;
  }
  return eventPageStore.enabledLocales;
});
</script>
